import {
  createAppLogger,
  createModuleLogger as originalCreateModuleLogger,
} from '#packages/data-collection/services/logger';

export const appLogger = createAppLogger('client-web');

export const createModuleLogger = (moduleName: string) =>
  originalCreateModuleLogger(moduleName, appLogger);
